import { render, staticRenderFns } from "./RichHorizontalIndicator.vue?vue&type=template&id=b0748c0c&scoped=true"
import script from "./RichHorizontalIndicator.vue?vue&type=script&lang=js"
export * from "./RichHorizontalIndicator.vue?vue&type=script&lang=js"
import style0 from "./RichHorizontalIndicator.vue?vue&type=style&index=0&id=b0748c0c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0748c0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0748c0c')) {
      api.createRecord('b0748c0c', component.options)
    } else {
      api.reload('b0748c0c', component.options)
    }
    module.hot.accept("./RichHorizontalIndicator.vue?vue&type=template&id=b0748c0c&scoped=true", function () {
      api.rerender('b0748c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-wizard/indicators/RichHorizontalIndicator.vue"
export default component.exports